import React, {useContext} from "react";
import Rest from "../helpers/Rest";

export const Customers = React.createContext(null)

function byName(a, b){
    return a.name.localeCompare(b.name)
}

export class CustomersContext extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            fetchCustomers: this.fetchCustomers.bind(this)
        }
    }

    async removeCustomers(ids){
        await Promise.all(ids.map(id => Rest.del(`customer/${id}`)))
        this.setState({
            customers: null
        })
    }

    async addCustomer(name){
        return Rest.post('customer', {
            name: name
        }).then((reply) => {
            const customers = this.state.customers
            customers.list.push(reply)
            customers.list.sort(byName)
            customers.map[reply.id] = reply
            return reply
        })
    }

    async fetchCustomers() {
        if (this.state.customers){
            return this.state.customers
        }
        const list = await Rest.get("customer/list")
        list.forEach(item => item.sites.sort(byName))
        const customers = {
            list: list.sort(byName),
            map: list.reduce((accum, item) => {
                accum[item.id] = item
                return accum
            }, {}),
            remove: this.removeCustomers.bind(this),
            add: this.addCustomer.bind(this)
        }
        this.setState({customers: customers})
        return customers
    }

    render(){
        return (
            <Customers.Provider value={this.state}>
                {this.props.children}
            </Customers.Provider>
        )
    }
}

export function useCustomers(){
    const customers = useContext(Customers)
    if (!customers){
        throw new Error('No customers context')
    }
    return customers
}
